module.exports = __webpack_public_path__ + "static/img/4.ed3488d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solu/4.png
// module id = EcpD
// module chunks = 0